<template>
    <b-container fluid>
      <b-row class="viewProfileContainer">
        <b-col class="pt-1">
          <Profile class="mb-2 profile-desktop-mode" :isOtherWall="true" v-if="!isOwner && !isMobileScreen" />
          <div class="profile-picture-container">
            <p class="profile-title">MY PROFILE</p>
            <b-row class="profile-mobile-mode">
              <div class="profile-section">
                <Profile class="mb-2" v-if="isMobileScreen" :isOtherWall="true" :otherUserInfo="userInfo" :isOwner="isOwner" />
                <div class="profile-wall-btn-div">
                  <UserNetwork :customer-id="$route.params.customerId" />
                  <router-link
                    :to="{
                      name: 'MemberWall',
                      params: { customerId: isOwner ? userInfo.id : this.$route.params.customerId },
                    }"
                  >
                    <b-button class="profile-wall-btn">Wall</b-button>
                  </router-link>
                </div>
              </div>
              <p class="profile-member-since">
                Member since
                {{ moment(userInfo.user.date_joined).format("DD.MM.YYYY") }}
              </p>
            </b-row>
            <b-row>
              <b-col>
                <div class="profile-picture">
                  <img :src="userInfo.profile_picture || defaultProfileImage" alt="" class="profile-desktop-mode">
                  <b-button
                    class="other-profile-follow-btn"
                    squared block
                    v-if="!isOwner && !!userInfo.follow_status.following === false"
                    @click="followReq"
                  >
                    <i class="far fa-eye"></i> Follow
                  </b-button>
                  <b-button
                    class="other-profile-follow-btn"
                    squared block
                    v-if="!isOwner && !!userInfo.follow_status.following === true"
                    v-on:click="UnFollowReq"
                  >
                    <i class="far fa-eye-slash"></i> Unfollow
                  </b-button>
                </div>
              </b-col>
            </b-row>
            <b-row class="profole-network-cont profile-desktop-mode">
              <b-col class="text-center m-1">
                <UserNetwork :customer-id="$route.params.customerId" />
              </b-col>
            </b-row>
            <b-row class="mt-2 ml-0 mr-0 segments-section">
              <div class="profile-segments-div">
                <b-badge
                  v-for="segment in userInfo.tags"
                  :key="segment.id"
                  class="profile-segment"
                  variant="dark"
                >{{ segment.name || "No Segment" }}
                </b-badge>
                <router-link :to="{ name: 'userSettings' }">
                  <b-badge
                    class="btn-add-more"
                    variant="light"
                    v-show="isOwner"
                  >
                    Add more
                  </b-badge>
                </router-link>
              </div>
            </b-row>
            <b-row class="no-gutters" v-show="!isOwner">
              <b-col class="profile-message-col" @click="sendMsg">
                <b-button
                  class="profile-message-btn"
                  variant="outline-warning"
                  block
                  squared
                >
                  <i class="far fa-envelope profile-message-icon"></i>
                  Message
                </b-button>
              </b-col>
              <b-col class="profile-network-col">
                <b-button
                  class="profile-follow-btn"
                  variant="outline-warning"
                  block
                  squared
                  v-if="userInfo.friendship_status.status === ''"
                  @click="
                    toNetwork(),
                      (userInfo.friendship_status.status = 'sent request')
                  "
                >
                  <i class="fas fa-user-plus profile-follow-icon"></i>
                  Add to Network
                </b-button>
                <b-button
                  class="profile-follow-btn p-0"
                  v-if="userInfo.friendship_status.status === 'sent request'"
                  block
                  squared
                >
                  <i class="fas fa-users profile-follow-icon"></i>
                  Request sent
                </b-button>
                <b-button
                  class="profile-follow-btn p-0"
                  v-if="
                    userInfo.friendship_status.status ===
                    'pending request or you'
                  "
                  block
                  squared
                >
                  <i class="fas fa-users profile-follow-icon"></i>
                  Sent you request
                </b-button>
                <b-button
                  class="profile-follow-btn p-0 Unfriend"
                  v-if="userInfo.friendship_status.status === 'friend'"
                  block
                  squared
                >
                  <i class="fas fa-user-times profile-follow-icon"></i>
                  Unfriend
                </b-button>
              </b-col>
            </b-row>
          </div>
        </b-col>
        <b-col>
          <b-row class="mb-3 profile-information-container">
            <b-col lg="9" md="8" sm="12" class="p-3">
              <p class="profile-owner-name">
                {{`${userInfo.user.first_name || "Name"} ${userInfo.user.last_name || "Surname"}`}}
              </p>
              <p class="profile-owner-title">
                {{ userInfo.job_title || "No Job" }}
              </p>
              <router-link
                :to="{
                  name: 'companyProfile',
                  params: { companyId: getId(userInfo.company) },
                }"
              >
                <p class="profile-owner-company-name">
                  {{ userInfo.company_name || "No Company" }}
                </p>
              </router-link>
              <p class="profile-member-since">
                Member since
                {{ moment(userInfo.user.date_joined).format("DD.MM.YYYY") }}
              </p>
            </b-col>
            <b-col lg="3" md="4" sm="12">
              <div class="profile-wall-btn-div">
                <router-link
                  :to="{
                    name: 'MemberWall',
                    params: { customerId: isOwner ? userInfo.id : this.$route.params.customerId },
                  }"
                >
                  <b-button class="profile-wall-btn" block squared>
                    <i class="fas fa-list profile-wall-icon"></i>
                    {{ `${userInfo.user.first_name || "Name"}’s Wall` }}
                  </b-button>
                </router-link>
              </div>
            </b-col>
          </b-row>

          <b-card no-body class="mt-2 mb-1">
            <b-card-header header-tag="header" :class="`${isBiographyExpanded ? '' : 'collapsed'}`" role="tab">
              <b-button  @click="isBiographyExpanded = !isBiographyExpanded" block v-b-toggle.biography-accordion variant="light" class="header-btn"
                ><p class="profile-biography-title">BIOGRAPHY</p> <i :class="`fas fa-angle-${isBiographyExpanded ? 'up': 'down'}`"></i
              ></b-button>
            </b-card-header>
            <b-collapse
              id="biography-accordion"
              accordion="biography-acc"
              role="tabpanel"
            >
              <b-card-body>
                <p class="profile-biography">{{ userInfo.biography }}</p>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body v-if="userInfo.display_configuration.show_email || userInfo.display_configuration.show_phone_number" class="mt-2 mb-1">
            <b-card-header header-tag="header" :class="`${isContactExpanded ? '' : 'collapsed'}`" role="tab">
              <b-button  @click="isContactExpanded = !isContactExpanded" block v-b-toggle.contact-accordion variant="light" class="header-btn"
                > <p class="profile-contacts-title">CONTACTS</p> <i :class="`fas fa-angle-${isContactExpanded ? 'up': 'down'}`"></i
              ></b-button>
            </b-card-header>
            <b-collapse
              id="contact-accordion"
              accordion="biography-acc"
              role="tabpanel"
            >
              <b-card-body>
                <b-col class="p-3 profile-biography-text-container">
                  <p
                    
                    class="profile-contacts-text"
                  >
                    <i
                      class="fas fa-envelope-square profile-contacts-icons"
                    ></i>
                    {{ userInfo.user.email }}
                  </p>
                  <p
                   
                    class="profile-contacts-text"
                  >
                    <i
                      class="fas fa-phone-square profile-contacts-icons"
                    ></i>
                    {{ userInfo.phone_number }}
                  </p>
                </b-col>
              </b-card-body>
            </b-collapse>
          </b-card>
        </b-col>
      </b-row>
      <b-modal
        v-model="congratulationModalShow"
        size="md"
        hide-footer
        @click="
          congratulationModalShow = false;
          networkModalText = '';
        "
      >
        <h3 style="text-align: center">CONGRATULATIONS!</h3>
        <p style="text-align: center">{{ networkModalText }}</p>
        <div class="congratulationModal">
          <router-link :to="{ name: 'network' }">My Network</router-link>
          <button
            @click="
              congratulationModalShow = false;
              networkModalText = '';
            "
          >
            Continue
          </button>
        </div>
      </b-modal>
      <notifications group="profile" position="bottom left" />
    </b-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import UserNetwork from '../../components/UserNetwork.vue';
import ownerId from '../../utils/getOwnerId';
import Profile from '../../components/profile/Profile.vue';
import getIDfromURL from '../../utils/getIDfromURL';
import defaultProfileImage from '../../assets/default-user-profile-image.png';
import BookedEvents from '../../components/bookedEvents/BookedEvents.vue';

export default {
  name: 'ProfilePage',
  components: {
    UserNetwork,
    Profile,
    BookedEvents,
  },
  data() {
    return {
      defaultProfileImage,
      isOwner: true,
      userInfo: {
        user: {},
        display_configuration: {},
        friendship_status: '',
        follow_status: '',
      },
      follower: '',
      following: '',
      requested_by: '',
      requested_to: '',
      networkModalText: '',
      showErrorAlert: false,
      congratulationModalShow: false,
      updatedUrl: '',
      owner: '',
      chatRoomId: null,
      page: 1,
      isBiographyExpanded: false,
      isContactExpanded: false,
    };
  },
  async mounted() {
    this.owner = await this.fetchUserPublicInfo();
    this.follower = this.owner.url;
    this.getChatRoomId();
    if (!this.isMobileScreen) {
      document.querySelectorAll('.header-btn').forEach((el) => {
        el.click();
      });
    }
  },
  computed: {
    ...mapGetters({
      isMobileScreen: 'isMobileScreen',
    }),
  },
  methods: {
    ...mapActions({
      fetchUserPublicInfo: 'user/fetchUserPublicInfo',
      follow: 'network/follow',
      addToNetwork: 'user/userInvitationRequest',
      unFollowMember: 'network/unFollowMember',
      conversationList: 'messages/getConversationList',
      createNewConversation: 'messages/createNewConversation',
    }),

    async followReq() {
      try {
        this.following = this.userInfo.url;
        const data = await this.follow({
          follower: this.follower,
          following: this.userInfo.url,
        });
        this.userInfo.follow_status.following_url = data.url;
        this.userInfo.follow_status.following = true;
        this.networkModalText = `You are now following ${this.userInfo.user.first_name} ${this.userInfo.user.last_name}.`;
        this.congratulationModalShow = true;
        this.$notify({
          group: 'profile',
          title: 'Success',
          text: 'Member have been added to your followers list!',
          type: 'success',
        });
      } catch (e) {
        console.log('e', e);
        if (e.response) {
          this.$notify({
            group: 'profile',
            title: 'Success',
            text: `${e.response.data}`,
            type: 'error',
          });
          this.networkModalText = '';
          this.congratulationModalShow = false;
        }
      }
    },
    // twice unfollow button click dont unfollowed member
    async UnFollowReq() {
      if (this.userInfo.follow_status.following_url) {
        try {
          const data = await this.unFollowMember(
            this.userInfo.follow_status.following_url,
          );
          this.userInfo.follow_status.following = false;
          this.$notify({
            group: 'profile',
            title: 'Success',
            text: 'Member have been deleted from your followers list!',
            type: 'success',
          });
        } catch (err) {
          this.$notify({
            group: 'profile',
            title: 'error',
            text: `${err.message}`,
            type: 'error',
          });
          console.log(err);
        }
      }
    },
    async getChatRoomId() {
      const { result } = await this.conversationList({
        conversationId: '',
        page: this.page,
      });
      result.docs.filter((res) => {
        if (res.receiver_id !== this.userInfo.id && result.docs.length) {
          for (let i = 2; i < result.docs.length; i += 1) {
            this.conversationList({
              conversationId: '',
              page: (this.page += 1),
            }).then(myRes => myRes.result.docs.filter((myResp) => {
              if (myResp.receiver_id === this.userInfo.id) {
                this.chatRoomId = res.chat_room_id;
              } else {
                return null;
              }
              return null;
            }));
          }
        } else {
          this.chatRoomId = res.chat_room_id;
        }
        return null;
      });
    },
    async sendMsg() {
      if (this.chatRoomId) {
        this.$router.push({
          name: 'currentMessage',
          params: {
            chatRoomId: this.chatRoomId,
          },
        });
      } else {
        try {
          const { result } = await this.createNewConversation({
            receiver_id: this.userInfo.user.id,
          });
          this.$router.push({
            name: 'currentMessage',
            params: {
              chatRoomId: result.chat_room_id,
              user: this.userInfo,
            },
          });
        } catch (err) {
          console.log(err);
        }
      }
    },
    async toNetwork() {
      try {
        this.requested_to = this.userInfo.url;
        await this.addToNetwork({
          requested_by: this.owner.url,
          requested_to: this.requested_to,
        });
        this.congratulationModalShow = true;
        this.networkModalText = `
        Your Network request has been successfully sent to
        ${this.userInfo.user.first_name} ${this.userInfo.user.last_name}.`;
        this.userInfo.friendship_status.status = true;
        this.$notify({
          group: 'profile',
          title: 'Success',
          text: 'Friend request has been sent!',
          type: 'success',
        });
      } catch (e) {
        console.log('e', e);
        if (e.response) {
          this.$notify({
            group: 'profile',
            title: 'Error',
            text: `${e.response.data}`,
            type: 'error',
          });
          this.networkModalText = '';
          this.congratulationModalShow = false;
        }
      }
    },
    moment(date) {
      return moment(new Date(date));
    },
    getId(url) {
      return getIDfromURL(url);
    },
  },
  async created() {
    const { customerId } = this.$route.params;
    if (customerId) {
      this.isOwner = ownerId === Number(customerId);
    }
    try {
      this.userInfo = await this.fetchUserPublicInfo(customerId);
    } catch (err) {
      this.$router.push({ name: 'NotFound' });
    }
  },
};
</script>
<style scoped>
.profile-mobile-mode {
  display: none;
}
.viewProfileContainer {
  display: grid;
  grid-template-columns: 310px 1fr;
  margin-bottom: 0.75rem;
  margin-right: 0.25rem;
}
.viewProfileContainer > div:nth-of-type(2) {
  padding: 0.25rem 0.75rem 0.75rem 0.75rem;
}
.profile-picture {
  width: 100%;
  text-align: center;
  background-size: cover;
  background-position: center;
}
.profile-picture img {
  width: 280px;
  height: 280px;
}
.profile-contact {
  font-size: 17px;
  color: #bd9d5f;
  font-family: Arial;
  line-height: 1.13;
  border-bottom: 1px solid #ebebeb;
  padding: 15px;
}
.profile-segments-div {
  padding: 10px;
}
.profile-segment {
    margin: 5px;
    padding: 4px 8px;
    background-color: #aaa;
    font-size: 12px;
    line-height: 1.17;
    letter-spacing: normal;
    font-family: Arial;
    text-align: left;
    color: #fff;
    font-weight: 400;
    border-radius: 0 10px 10px 10px;
}
.profile-message-btn {
  font-size: 14px;
  text-align: center;
  background-color: #bd9d5f;
  color: white;
  box-shadow: none;
}
.profile-message-btn:hover {
  color: #bd9d5f;
  background-color: #fff;
}
.profile-add-to-net-btn {
  background-color: #bd9d5f;
  color: white;
  font-size: 14px;
  text-align: center;
  border: 0;
  box-shadow: none;
  min-height: 35px;
  min-width: 30px;
}
.profile-message-icon,
.profile-add-to-net-icon,
.profile-wall-icon {
  font-size: 13.5px;
}
.profile-owner-name {
  font-family: Arial;
  font-size: 28px;
  line-height: 1.17;
  text-align: left;
  font-weight: bold;
  color: #333333;
  margin: 0;
  text-transform: capitalize;
}
.profile-owner-title {
  font-family: Arial;
  font-size: 18px;
  line-height: 1.17;
  font-weight: bold;
  color: #666666;
  margin: 0;
  text-transform: capitalize;
}
.profile-owner-company-name {
  font-family: Arial;
  font-size: 18px;
  line-height: 1.17;
  font-size: 18px;
  color: #bd9d5f;
  text-transform: capitalize;
}
.profile-member-since {
  font-family: Arial;
  font-size: 11px;
  line-height: 1.09;
  text-align: left;
  color: #666666;
  margin: 0;
}
.contentColumn {
  word-wrap: break-word !important;
}
.profile-biography-title,
.profile-contacts-title {
  font-family: Montserrat;
  font-size: 18px;
  line-height: 1.22;
  text-align: center;
  color: #333333;
  margin: 0;
}
.profile-biography-title-container,
.profile-biography-text-container,
.profile-picture-container,
.profile-information-container {
  background-color: white;
}
.profile-information-container {
  margin-right: 0;
}
.profile-information-container > div:nth-of-type(2) {
  display: flex;
  align-items: end;
  justify-content: end;
  padding-bottom: 20px;
}
.profile-biography {
  font-family: Arial;
  font-size: 13px;
  line-height: 1.15;
  text-align: left;
  color: #666666;
}
.profile-contacts-icons {
  color: #aaaaaa;
  font-size: 15px;
}
.profile-contacts-text {
  font-family: Arial;
  font-size: 13px;
  line-height: 1.15;
  text-align: left;
  color: #bd9d5f;
}
.profile-wall-btn {
  background-color: #bd9d5f;
  color: white;
  font-size: 15px;
  border: 0;
  border-right: 1px solid white;
  box-shadow: none;
  padding: 10px 24px;
}
.btn-add-more:hover, .profile-segment:hover {
  cursor: pointer;
  background-color: #BD9D5F;
  color: white;
}
.btn-add-more {
  font-size: 12px;
  padding: 4px 8px;
  user-select: none;
  margin:  7px 7px 7px 0px;
  color: #7f7f7f;
  background: #ebebeb;
  box-shadow: none;
  border-radius: 0 8px 8px 8px;
  font-weight: normal;
}

.btn-edit-profile {
  float: right;
  font-size: 15px;
  margin-bottom: 25px;
  color: #bd9d5f;
  background: #ffffff;
  box-shadow: none;
}
.owner-small-profile {
  max-width: 270px;
}
.profile-follow-btn {
  font-size: 13px;
  height: 100% !important;
  background-color: #bd9d5f;
  color: #fff;
  padding: 2px;
}
.profile-follow-btn:hover {
  color: #bd9d5f;
  background-color: #fff;
}
.other-profile-follow-btn {
  font-size: 14px;
  margin-top: 5px;
  border: 1px solid #bd9d5f;
  background-color: #bd9d5f;
  box-shadow: none;
  font-family: Arial;
}
.other-profile-follow-btn:hover {
  color: #bd9d5f;
  background-color: #fff;
}
.other-profile-follow-btn,
.profile-add-to-net-btn:active,
.profile-message-btn:active {
  box-shadow: none !important;
}
.profile-network-col {
  margin-left: 1px;
}
.profile-message-col {
  margin-right: 1px;
}
.profole-network-cont {
  border-bottom: 1px solid #ebebeb;
  justify-content: center;
}
.congratulationModal {
  display: flex;
  justify-content: center;
  align-items: center;
}
.congratulationModal a,
.congratulationModal button {
  color: #bd9d5f;
  background-color: #fff;
  border: 1px solid #bd9d5f;
  padding: 3px 10px;
  margin-right: 10px;
}
.congratulationModal a:hover,
.congratulationModal button:hover {
  color: #fff;
  background-color: #bd9d5f;
  border: 1px solid #fff;
}
@media (max-width: 991px) {
  .bookedEventsColumn {
    padding: 0;
  }
  .profile-information-container {
    margin-right: -15px;
  }
}
.profile-title {
  display: none;
}
@media (max-width:768px) {
  .profile-member-since {
    border-top: 1px solid #ebebeb;
    border-bottom: 1px solid #ebebeb;
  }
  .profile-picture-container {
    background-color: #fff !important;
    border-radius: 0 10px 10px 10px;
  }
  .profile-title {
    text-align: center;
    text-transform: uppercase;
    display: block;
    border-bottom: 1px solid #ebebeb;
    margin-bottom: 0;
    padding-top: 1rem;
    padding-bottom: 1rem;
    color: #666666;
  }
  .viewProfileContainer {
    margin-right: 0;
  }
  .container-fluid {
    padding-right: 0;
  }
  .viewProfileContainer {
    grid-template-columns: 1fr;
    margin-bottom: 0;
  }
  .viewProfileContainer > div:nth-of-type(1) {
    padding-right: 0;
  }
  .viewProfileContainer > div:nth-of-type(2) {
    padding: 0px 15px 0 30px;
  }
  .profile-desktop-mode,
  .profile-information-container {
    display: none;
  }
  .profile-mobile-mode {
    display: block;
    margin: 0;
  }
  .profile-mobile-mode > .profile-section {
    display: grid;
    grid-template-columns: 3fr 1fr;
    background-color: #fff;
  }
  .profile-mobile-mode >.profile-section >div {
    margin-bottom: 0 !important;
  }
  .profile-mobile-mode .profile-member-since {
    background-color: #fff;
    padding: 4px;
    margin-top: 1px;
    font-size: 8px;
    line-height: 10px;
    text-align: center;
  }
  .segments-section {
    background-color: #fff;
    margin-top: 1px !important;
  }
  .profile-wall-btn-div {
    position: relative;
  }
  .profile-wall-btn-div>div {
    width: fit-content !important;
    padding: 0;
    margin: 0px;
    position: absolute;
    top: 0;
    right: 8px;
  }
  .profile-wall-btn-div>a {
    position: absolute;
    bottom: 3px;
    right: 8px;
  }
  .profile-mobile-mode .profile-wall-btn {
    padding: 4px 8px;
    font-size: 12px;
    background-color: #f3f3f3;
    color: #7f7f7f;
    border: none;
    border-radius: 0 10px 10px 10px;
  }
  .profile-picture-container {
    border-radius: 0 10px 10px 10px;
    overflow: hidden;
    background-color: transparent;
    margin-top: 4px;
  }
  .profile-picture {
    margin-top: -3px;
  }
  .contentColumn > div:first-child {
    border-radius: 0 10px 0 0;
    overflow: hidden;
  }
  .contentColumn > div:nth-of-type(2) {
    border-radius: 0 0 10px 10px;
    overflow: hidden;
  }
  .contentColumn > div:last-child {
    border-radius: 0 10px 10px 10px;
    overflow: hidden;
  }
  .profile-biography-title-container p {
    font-size: 13px;
  }
  .profile-biography-text-container p {
    font-size: 12px;
    text-align: center;
  }
}
.card  {
    margin: 0 -15px;
    border-radius: 0 10px 10px 10px;
  }
  .card-header {
    background-color: #fff;
    border-radius: 0 10px 0 0;
  }
  .card-header.collapsed {
    border-radius: 0 10px 10px 10px;
  }
  .card-header .header-btn {
    background-color: #fff;
    border: none;
    outline: none;
    box-shadow: none !important;
  }
.header-btn {
    position: relative;
  }
.header-btn i {
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 23px;
}
</style>
